import { Order } from '@m4a3/api-client';
import { hasRouteForOrder, orderHasPadsAssigned, shouldShowDropPointConfirmationForOrder } from './orderUtils';

export type RequiredAction = {
  id: 'confirm-route' | 'assign-pad' | 'suggest-delivery-spot';
  title: string;
};

/**
 * Determines which required actions should be shown for an order
 * Used by both OrderDetails and OrderCard to maintain consistency
 */
export const getRequiredActionsForOrder = (order: Order | null): RequiredAction[] => {
  if (!order) return [];
  
  const actions: RequiredAction[] = [];
  
  // 1. Suggest delivery spot (HIGHEST PRIORITY) - exact conditions from shouldShowDropPointConfirmationForOrder
  const shouldShowSuggestDeliverySpot = shouldShowDropPointConfirmationForOrder(order);
  
  if (shouldShowSuggestDeliverySpot) {
    actions.push({
      id: 'suggest-delivery-spot',
      title: 'Needs delivery spot'
    });
  }
  
  // 2. Assign pad - when status is RECEIVED_FROM_STORE and missing pads
  if (order.status === 'RECEIVED_FROM_STORE' && 
      (!order.originLandingPadId || !order.destinationLandingPadId)) {
    actions.push({
      id: 'assign-pad',
      title: 'Assign pad'
    });
  }
  
  // 3. Confirm route - exact conditions from getOrderActionCardData
  const shouldShowConfirmRoute = !hasRouteForOrder(order) &&
                                order.status === 'RECEIVED_FROM_STORE' &&
                                orderHasPadsAssigned(order);
  
  if (shouldShowConfirmRoute) {
    actions.push({
      id: 'confirm-route',
      title: 'Confirm route'
    });
  }
  
  return actions;
};

